import React, { Component } from 'react';
import Button from '../../components/Button';
import Preloader from '../../components/Preloader';
import queryString from 'query-string'
import {deleteData} from '../../utils/DeleteRequest'
import { Redirect } from 'react-router'

class PageUnsubscribe extends Component {
  state = {
    deleted: false,
    redirect: false
  };

  handleUnsubscribe = (e) => {
    e.preventDefault();
    if (this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      if (deleteData('/vacancy/vacancy-unsubscribe/', values.subscriber, values.token)) {
        this.setState({ deleted: true });
        setTimeout(() => {
          this.setState({ redirect: true });
        }, 5000);
      };
    }
  }

  render() {
    return (
      <div className="container container--indentVertical container--flex container--flexCenter">
        {
          this.state.deleted ?
          <div>
            <h1 className="text text--h5 text--center text--bottom24">Вы успешно отписаны.<br/>Сейчас вы будете переадресованы на главную страницу</h1>
            <Preloader/>
            {
              this.state.redirect &&
              <Redirect to="/" />
            }
          </div> :
          <div>
            <h1 className="text text--h3 text--center text--bottom24">Подтвердите, что больше<br/> не хотите получать новые вакансии</h1>
            <div className="row row--center">
              <Button link="/" text="Подтверждаю" modifier="button--indents" onClick={this.handleUnsubscribe} />
              <Button link="/" text="Отмена" modifier="button--indents" />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default PageUnsubscribe;




// WEBPACK FOOTER //
// ./src/pages/PageUnsubscribe/index.js